// extracted by mini-css-extract-plugin
export default {"row":"vendor-vip_row__t33fW","mt_16":"vendor-vip_mt_16__SMUqG"};